import { Pressed } from 'libs/ui/Pressed';
import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const ContentStyled = styled(Pressed, {
  shouldForwardProp: (prop) => prop !== 'interactive',
})<{ interactive?: boolean }>(({ theme, interactive = true }) => ({
  border: `1px solid ${Colors.gray300}`,
  backgroundColor: Colors.white,
  borderRadius: 4,
  paddingLeft: 4,
  paddingRight: 4,
  paddingTop: 3,
  paddingBottom: 3,
  height: 24,

  '.copyButton-icon': {
    color: Colors.black,
    transition: theme.transitions.create(['fill']),
  },

  ...(interactive && {
    '&:hover': {
      backgroundColor: Colors.blue100,
      border: '1px solid transparent',

      '.copyButton-icon': {
        color: Colors.blue500,
      },
    } as CSSObject,

    '&:active': {
      backgroundColor: Colors.blue100,
    },
  }),
}));
